var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldFavIconShow
    ? _c(
        "div",
        { staticClass: "i-favorite" },
        [
          _vm.$scopedSlots.default
            ? _vm._t("default", null, {
                isActive: _vm.isActive,
                title: _vm.title,
                onClick: _vm.favoriteHandler,
              })
            : [
                _c(
                  "div",
                  {
                    staticClass: "star-btn",
                    class: {
                      small: _vm.small,
                      animate: _vm.clicked,
                      active: _vm.isActive,
                    },
                    attrs: { title: _vm.title },
                    on: { click: _vm.favoriteHandler },
                  },
                  [
                    _c("i", { staticClass: "isif isif-star back" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "isif isif-star front" }),
                  ]
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }